module.exports = __webpack_public_path__ + "img/vector-seacrh-filter.dae9f717.svg";